import * as Sentry from "@sentry/minimal";
import { cc } from "../index";
const nodeColors = {
    DEBUG: `\x1b[34m%s\x1b[0m`,
    INFO: `\x1b[36m%s\x1b[0m`,
    NOTICE: `\x1b[33m%s\x1b[0m`,
    WARNING: `\x1b[33m%s\x1b[0m`,
    ERROR: `\x1b[31m%s\x1b[0m`,
    CRITICAL: `\x1b[31m%s\x1b[0m`,
    ALERT: `\x1b[31m%s\x1b[0m`,
    EMERGENCY: `\x1b[31m%s\x1b[0m`,
};
const browserColors = {
    DEBUG: `color: blue; font-weight: bold;`,
    INFO: `color: purple; font-weight: bold;`,
    NOTICE: `color: yellow; font-weight: bold;`,
    WARNING: `color: yellow; font-weight: bold;`,
    ERROR: `color: red; font-weight: bold;`,
    CRITICAL: `color: red; font-weight: bold;`,
    ALERT: `color: red; font-weight: bold;`,
    EMERGENCY: `color: red; font-weight: bold;`,
};
export function createLogger(namespace, level) {
    const debugEnv = process.env.DEBUG || process.env.DEBUG2 || "";
    const debugEnvSplit = debugEnv
        .split(",")
        .filter((e) => !!e)
        .map((e) => e.toLowerCase());
    const isEnabled = debugEnvSplit.indexOf(namespace.toLowerCase()) !== -1;
    const isServer = typeof window === "undefined";
    const isCloudLogging = cc.production && isServer;
    return (data, extra, namespaceOverride) => {
        if (!isEnabled)
            return;
        if (!isCloudLogging) {
            if (typeof extra === "object" && Object.keys(extra).length === 0)
                extra = undefined;
            const logData = [`[${namespaceOverride || namespace}]`, data, extra].filter((d) => !!d);
            if (isServer) {
                logData.unshift(nodeColors[level]);
            }
            else {
                logData.splice(1, 0, browserColors[level]);
                logData[0] = `%c${logData[0]}`;
            }
            console.log(...logData);
        }
        else {
            let logData = { severity: level, namespace: namespaceOverride || namespace };
            if (typeof data === "string") {
                logData.message = data;
            }
            else if (data instanceof Error) {
                logData.name = data.name;
                logData.message = data.message;
                logData.stack = data.stack;
            }
            else {
                logData = Object.assign(Object.assign({}, data), logData);
            }
            logData.extra = extra;
            try {
                console.log(JSON.stringify(logData));
            }
            catch (e) {
                Sentry.captureException(e, {
                    extra: {
                        where: "logger_stringify",
                    },
                });
                console.error("Failed to stringify log");
            }
        }
    };
}
// Base Levels
const debug = createLogger("DEBUG", "DEBUG");
const info = createLogger("INFO", "INFO");
const notice = createLogger("NOTICE", "NOTICE");
const warn = createLogger("WARN", "WARNING");
const error = createLogger("ERROR", "ERROR");
const critical = createLogger("CRITICAL", "CRITICAL");
const alert = createLogger("ALERT", "ALERT");
const emergency = createLogger("EMERGENCY", "EMERGENCY");
// Application namespaces
const request = createLogger("REQUEST", "DEBUG");
// OLD DEBUG LOGS
// const error = debug("ERROR");
// const warn = debug("WARN");
// const info = debug("INFO");
// const request = debug("REQUEST");
export const logger = {
    debug: debug,
    info: info,
    notice: notice,
    warn: warn,
    error: error,
    critical: critical,
    alert: alert,
    emergency: emergency,
    request: request,
    captureWarning: (message, e) => {
        warn(message);
        if (e)
            warn(e);
        Sentry.captureMessage(message);
    },
    captureException: (e, message) => {
        error(e);
        if (message)
            error(message);
        Sentry.captureException(e);
    },
    captureException2: (e, ctx) => {
        error(e, ctx);
        Sentry.captureException(e, ctx);
    },
    // Capture exception util
    ceu: (where, extra) => {
        return (e) => {
            const ctx = { extra: Object.assign({ where }, extra) };
            error(e, ctx);
            Sentry.captureException(e, ctx);
        };
    },
};
//# sourceMappingURL=index.js.map